module.exports = __webpack_public_path__ + "img/unknown_token.bf5f50ee.png";